module.exports = __webpack_public_path__ + "img/photo-1.e55d616c.webp";